import MDBox from "../../materialDashboard/components/MDBox";
import MDInput from "../../materialDashboard/components/MDInput";
import MDPagination from "../../materialDashboard/components/MDPagination";
import Icon from "@mui/material/Icon";


const Pagination = ({table, pagination}) => {
    const pageOptions = table.getPageOptions()

    if(pageOptions.length < 2){
        return null;
    }

    const gotoPage = table.setPageIndex;
    const { pagination: {pageIndex}} = table.getState()
    const canPreviousPage = table.getCanPreviousPage();
    const canNextPage = table.getCanNextPage();
    const previousPage = table.previousPage;
    const nextPage = table.nextPage;

    const customizedPageOptions = pageOptions.map((option) => option + 1);

    // Handler for the input to set the pagination index
    const handleInputPagination = ({ target: { value } }) =>
        value > pageOptions.length || value < 0 ? gotoPage(0) : gotoPage(Number(value));

    // Setting value for the pagination input
    const handleInputPaginationValue = ({ target: value }) => gotoPage(Number(value.value - 1));

    const paginationEl =  pageOptions.length > 6 ?
        <MDBox width="5rem" mx={1}>
            <MDInput
                inputProps={{type: "number", min: 1, max: customizedPageOptions.length}}
                value={customizedPageOptions[pageIndex]}
                onChange={(handleInputPagination, handleInputPaginationValue)}
            />
        </MDBox>
        :
        pageOptions.map((option) => (
            <MDPagination
                item
                key={option}
                onClick={() => gotoPage(Number(option))}
                active={pageIndex === option}
            >
                {option + 1}
            </MDPagination>
        ));

    return <MDPagination
        variant={pagination.variant ? pagination.variant : "gradient"}
        color={pagination.color ? pagination.color : "info"}
    >
        {canPreviousPage && (
            <MDPagination item onClick={() => previousPage()}>
                <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
            </MDPagination>
        )}
        {
            paginationEl
        }
        {canNextPage && (
            <MDPagination item onClick={() => nextPage()}>
                <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
            </MDPagination>
        )}
    </MDPagination>
}

export default Pagination;